export default {
  namespaced: true,
  planning: {
    title: 'Planejamento | Planejamento',
    activity_type: 'Tipo de atividade programada',
    business_division: 'Divisão do negócio',
    federal_entity: 'Entidade federativa',
    rems: 'REMS',
    property_name: 'Nome do imóvel',
    property_type: 'Tipo de imóvel',
    property_types_in_selection: 'Tipos de imóvel na seleção',
    start_date: 'Data início',
    end_date: 'Data fim',
    start_programming: 'Iniciar programação',
    start_programming_modal_title: 'Iniciar programação',
    start_programming_modal_message: 'O formulário de programação será implementado aqui.',
    activity_type_to_schedule: 'Tipo de atividade a programar',
    form_templates: 'Modelos de formulário',
    form_templates_placeholder: 'Selecione um ou mais modelos…',
    evaluacion_riesgo: 'Avaliação de risco',
    ejercicio_operativo: 'Exercício operacional',
    simulacro: 'Simulacro',
    auto_evaluacion_seguridad: 'Auto avaliação de segurança',
    selected_units: 'Unidades selecionadas',
    assigned_to: 'Atribuído a',
    no_units_selected: 'Selecione imóveis acima para adicioná-los à tabela.',
    units_label: 'Imóveis',
    last_sra_date: 'Data do último SRA',
    residual_risk_level: 'Nível de risco residual',
    status: 'Estado',
    planning_id: 'ID do planejamento',
    list_col_assigned_to: 'Atribuído a',
    list_col_in_review_by: 'Em revisão por',
    list_col_accepted_cancelled: 'Aprovado / rejeitado por',
    list_status_by: 'Por {name}',
    last_status_change: 'Última mudança de estado',
    status_draft: 'Em progresso',
    status_review: 'Em revisão',
    status_additional: 'Segunda aprovação',
    status_approved: 'Aprovado',
    status_rejected: 'Rejeitado',
    status_released: 'Enviado',
    send_to_review: 'Enviar para revisão',
    send_to_approval: 'Enviar para aprovação',
    approve: 'Aprovar',
    reject: 'Rejeitar',
    reject_comment: 'Comentário de rejeição',
    reject_comment_placeholder: 'Motivo da rejeição (obrigatório)',
    send_programming: 'Enviar programação',
    target_date: 'Data alvo',
    select_reviewer: 'Selecione revisor',
    select_approver: 'Selecione aprovador',
    send_second_approval: 'Enviar para segunda aprovação',
    accept_programming: 'Aceitar programação',
    download_planning: 'Baixar planejamento',
    year: 'Ano',
    fecha_inicio: 'Data início',
    fecha_fin: 'Data fim',
    user: 'Usuário',
    comment: 'Comentário',
    item_comment_prefix: 'Comentário',
    add_comment: 'Adicionar comentário',
    comment_placeholder: 'Escreva um comentário',
    add_extra_units: 'Adicionar imóveis extras',
    add_extra_units_placeholder: 'Buscar e selecionar imóveis extras...',
    status_change_history_title: 'Histórico de comentários por mudança de estado',
    status_change_transition: 'De {from} para {to}',
    toast_planning_title: 'Planejamento',
    toast_planning_id_line: 'ID do planejamento: {id}',
    exit: 'Sair',
    scheduled_programming_notification: 'Você tem planejamento programado',
  },
}
